export default __webpack_public_path__ + "static/media/demo.91533824.mp4";